document.addEventListener('DOMContentLoaded', function() {
  const trigger = document.querySelector('[data-specs-info-trigger]');
  const tooltip = document.querySelector('[data-specs-tooltip]');
  
  if (!trigger || !tooltip) return;
  
  let hideTimeout;
  
  trigger.addEventListener('click', function(e) {
    e.preventDefault();
    
    clearTimeout(hideTimeout);
    
    tooltip.classList.add('is-visible');
    
    hideTimeout = setTimeout(function() {
      tooltip.classList.remove('is-visible');
    }, 5000);
  });
});
